import { render } from "./HeaderMenuItem.vue?vue&type=template&id=1a6cf141"
import script from "./HeaderMenuItem.vue?vue&type=script&lang=js"
export * from "./HeaderMenuItem.vue?vue&type=script&lang=js"

import "./HeaderMenuItem.vue?vue&type=style&index=0&id=1a6cf141&lang=scss"

import exportComponent from "/builds/front-end/site-cms/deploy_site_cdn/site/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__loftyFile', 'src/modules/md-header/HeaderMenuItem.vue'],['render',render],['__file',"HeaderMenuItem.vue"]])

export default __exports__